import { render, staticRenderFns } from "./deanSectionTitleItem.vue?vue&type=template&id=1ecec32e&scoped=true"
import script from "./deanSectionTitleItem.vue?vue&type=script&lang=ts"
export * from "./deanSectionTitleItem.vue?vue&type=script&lang=ts"
import style0 from "./deanSectionTitleItem.vue?vue&type=style&index=0&id=1ecec32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecec32e",
  null
  
)

export default component.exports